export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16 bg-gradient-to-br from-primary-500 to-primary-700 rounded-3xl p-8 md:p-14 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-64 h-64 bg-accent-400/20 rounded-full blur-3xl -translate-y-1/2 translate-x-1/4"></div>
          <div className="absolute bottom-0 left-0 w-48 h-48 bg-accent-300/15 rounded-full blur-3xl translate-y-1/2 -translate-x-1/4"></div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" style={{ fontFamily: 'var(--font-heading)' }}>
              追更助手
            </h2>
            <p className="text-white/85 text-base md:text-lg leading-relaxed mb-6 max-w-xl">
              随时随地掌握漫画追更动态。追更助手支持个性化追更列表管理、更新即时提醒、阅读进度同步，让你在任何设备上都能第一时间获取漫画最新更新。下载漫蛙漫画网追更助手，追漫体验全面升级。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white text-primary-600 font-semibold rounded-full hover:bg-white/90 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                移动端入口
              </a>
              <a
                href="#app"
                className="inline-flex items-center gap-2 px-7 py-3 bg-white/15 text-white font-semibold rounded-full border border-white/30 hover:bg-white/25 transition-all duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-computer-line text-lg"></i>
                网页版体验
              </a>
            </div>
          </div>

          <div className="relative z-10 flex-shrink-0">
            <div className="w-56 md:w-64 h-auto">
              <img
                src="https://readdy.ai/api/search-image?query=Clean%20modern%20mobile%20app%20mockup%20showing%20a%20manga%20tracking%20interface%20with%20colorful%20comic%20thumbnails%2C%20warm%20coral%20and%20amber%20color%20scheme%2C%20floating%20phone%20screen%2C%20minimal%20design%2C%20soft%20lighting%2C%20isometric%20angle%2C%20artistic%20presentation&width=500&height=800&seq=manwa-app-mockup&orientation=portrait"
                alt="漫蛙漫画网追更助手移动端界面"
                className="w-full h-auto object-contain"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}